import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';
import z from 'zod';

import '@xyflow/react/dist/style.css';

import { LoomCommandRegistryProvider } from '@/components/features/loom/providers/LoomCommandRegistryProvider';
import { LoomStoreProvider } from '@/components/features/loom/providers/LoomStoreProvider';
import { TemplateCanvasWithChat } from '@/components/features/loom/templates/TemplateCanvasWithChat';

export const Route = createFileRoute('/_protected/t/$tenantId/loom/templates/$templateId')({
  component: TemplateCanvasPage,
  ssr: false,
  validateSearch: z.object({
    chatConversationId: z.string().optional().catch(undefined),
  }),
});

function TemplateCanvasPage() {
  const { templateId } = Route.useParams();
  const { chatConversationId } = Route.useSearch();

  return (
    <ReactFlowProvider>
      <LoomStoreProvider>
        <LoomCommandRegistryProvider>
          <TemplateCanvasWithChat
            templateId={templateId === 'new' ? undefined : templateId}
            chatConversationId={chatConversationId}
          />
        </LoomCommandRegistryProvider>
      </LoomStoreProvider>
    </ReactFlowProvider>
  );
}
